import { Button } from '@/app/components/Button'
import { Link } from '@/app/components/Link'
import { TrackingLocation } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'
import { NavQueryResult } from '@/sanity.types'

interface NavigationItemProps {
  classNames?: {
    root?: string
    button?: string
    link?: string
  }
  item: NonNullable<NavQueryResult[number]['menu']['items']>[number] | null
  tracking: TrackingLocation
}

export const NavigationItem = function ({ classNames, item, tracking }: NavigationItemProps) {
  if (!item) {
    return null
  }

  return (
    <li key={item._key} className={cn('', classNames?.root)}>
      {item.itemType === 'link' && item.link ? (
        <Link link={item.link} tracking={tracking} className={cn('', classNames?.link)} />
      ) : item.itemType === 'button' && item.button ? (
        <Button button={item.button} tracking={tracking} className={cn('', classNames?.button)} />
      ) : null}
    </li>
  )
}
